// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zt-z","tooltipWrapper":"At-z","icon":"Bt-z","tooltip":"Ct-z","content":"Dt-z"};